import { render, staticRenderFns } from "./ChartsListView.vue?vue&type=template&id=f8627762&"
import script from "./ChartsListView.vue?vue&type=script&lang=ts&"
export * from "./ChartsListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports